<template>
    <div>
        <div class="listingPageTitle">
            <h1>Client Maintenance</h1>
            <ItemModal :itemName="'Client'"
                            :formRows="newClientFormRows"
                            :saveItemFunction="saveRecord"
                            :refreshItemsFunction="loadRecords"></ItemModal>
        </div>
        <div class="searchContainer">
            <div class="formRow"><span class="inputTitle">Search Code: </span><input type="text" v-model="searchText" /></div>
            <div class="formRow"><span class="inputTitle">Active Only: </span><input type="checkbox" v-model="onlyShowActive" /></div>
        </div>
        <hr />
        <ListingTable :columns="columns" :filterCriteria="filterCriteria" :actions="actionMappings" 
            :key="componentKey" :intitializationParameters="{ sortBy: 'name'}" />
    </div>
</template>

<script>
import { data } from '../../shared/data';
import { downloadCsv } from '../../shared/downloadCsv';
import ItemModal from '@/components/ItemModal.vue';
import ListingTable from '@/components/shared/ListingTable.vue';

export default {
    name: 'ClientListing',
    components: { ItemModal, ListingTable },
    data: function() {
        return {
            clients: [],
            searchText: '',
            onlyShowActive: true,
            componentKey: 0,
            columns: [ 
                {
                    headerDisplayName: "ID",
                    width: "10%",
                    fieldName: "id"
                },
                {
                    headerDisplayName: "Name",
                    width: "35%",
                    fieldName: "name",
                    isEditLink: true
                },
                {
                    headerDisplayName: "Code",
                    width: "15%",
                    fieldName: "code"
                },
                {
                    headerDisplayName: "Download Activity Log",
                    width: '15%',
                    columnType: "buttons",
                    itemModalRows: [
                        {
                            name: 'Start Date',
                            propertyName: 'startDate',
                            element: 'date'
                        },
                        {
                            name: 'End Date',
                            propertyName: 'endDate',
                            element: 'date'
                        },
                        {
                            element: 'text',
                            text: 'Leave dates empty to retrieve all records'
                        }
                    ],
                    itemName: 'Activity Log CSV',
                    saveItemFunction: this.downloadActivityLogCSV,
                    openModalButton: '<i class="fa-solid fa-file-arrow-down"></i>'
                },
                {
                    headerDisplayName: "Download Feedback",
                    width: '15%',
                    columnType: "buttons",
                    itemModalRows: [
                        {
                            name: 'Start Date',
                            propertyName: 'startDate',
                            element: 'date'
                        },
                        {
                            name: 'End Date',
                            propertyName: 'endDate',
                            element: 'date'
                        },
                        {
                            element: 'text',
                            text: 'Leave dates empty to retrieve all records'
                        }
                    ],
                    itemName: 'Feedback CSV',
                    saveItemFunction: this.downloadFeedbackCSV,
                    openModalButton: '<i class="fa-solid fa-file-arrow-down"></i>'
                },
                {
                    width: "10%",
                    columnType: "buttons",
                    showDeleteFieldName: "isActive",
                    showUndeleteFieldName: "!isActive"
                }
            ],
            newClientFormRows: [
                {
                    name: 'Name',
                    propertyName: 'clientName',
                    required: true,
                    element: 'input'
                },
                {
                    name: 'Code',
                    propertyName: 'clientCode',
                    required: true,
                    element: 'input'
                },
                {
                    name: 'Site URL',
                    propertyName: 'siteUrl',
                    required: true,
                    element: 'input'
                }
            ],
            actionMappings: {
                onLoadData: this.loadRecords,
                onDelete: this.deleteRecord, 
                onUndelete: this.reactivateRecord,
                editHrefBuilder: this.editHrefBuilder
            },
        }
    },
    computed: {
        filterCriteria () {
            var criteria = [];
            if(this.searchText != "") 
                criteria.push( {
                    dataType: "String",
                    fieldName: "code",
                    value: this.searchText
                });

            if(this.onlyShowActive) {
                criteria.push( {
                    dataType: "Boolean",
                    fieldName: "isActive",
                    value: true
                });

            }
            return criteria;
        }
    },
    methods: {
        loadRecords: async function() {
            return await data.getAllClients(this.searchText, false);
        },
        editHrefBuilder: function(cli) {
            return '/ClientEdit?ID=' + cli.id + '&Code=' + cli.code;
        },
        deleteRecord: async function(cli) {
            if(confirm('Are you sure you want to delete this client?')) {
                var status = this.processDeactivateResult(await data.deleteClient(cli.id));
                if(status.success) 
                    cli.isActive = false;
            }
        },
        saveRecord: async function(cli) {
            cli.languages = ['English'];
            return await this.saveClient(cli, true);
        },
        saveClient: async function(cli, redirectToEditFlag) {
            var retObject =  this.processSaveResult(await data.saveClient(cli));

            if(retObject.success) {
                if(redirectToEditFlag && retObject.id) {
                    cli.id = retObject.id;
                    window.location.href = this.editHrefBuilder(cli);
                }
                else 
                    return retObject;
            }
            else
                return retObject;

        },
        reactivateRecord: async function(cli) {
            cli.isActive = true;
            var status = await this.saveClient(cli);
            if(!status.success)
                cli.isActive = false;
        },
        downloadActivityLogCSV: async function(dates, client) {
            return downloadCsv.downloadCsvWithDates(dates, data.getActivityLogs, client.code, 'Activity_Logs');
        },
        downloadFeedbackCSV: async function(dates, client) {
            return downloadCsv.downloadCsvWithDates(dates, data.getClientFeedback, client.code, 'Feedback');
        }
    }
}
</script>

<style scoped>
    .searchContainer {
        text-align: left;
        margin: 20px 50px 25px;
    }
    .searchContainer .formRow {
        margin: 0px 0;
    }
    .inputTitle {
        padding-right: 15px;
       
    }
    .searchContainer button {
        height: 40px;
        width: 250px;
        border-radius: 5px;
        border-color: rgb(239, 239, 239);
        font-size: 16px;
        cursor: pointer;
    }
</style>